import type { RowAction } from "./explorerActions";

/**
 * The sharings table's action model (sibling to utils/explorerActions.ts
 * and utils/memberActions.ts, built on the same `RowAction` contract): a
 * sharing row's per-row menu (three-dots, right-click) is built from this
 * same list, alongside the shared `openAction` from explorerActions.ts.
 */
export function closeSharingAction(onSelect: () => void): RowAction {
  return { key: "close", type: "close", label: "Close sharing", onSelect };
}
